/**
 * External modules
 */
import { atom } from "recoil";

export const pageCountState = atom({
  key: "document-page-count",
  default: 0,
});
